import { render } from "./InvestmentPlan.vue?vue&type=template&id=629fda77&scoped=true"
import script from "./InvestmentPlan.vue?vue&type=script&lang=js"
export * from "./InvestmentPlan.vue?vue&type=script&lang=js"

import "./InvestmentPlan.vue?vue&type=style&index=0&id=629fda77&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629fda77"]])

export default __exports__